const baseStyle = (props: Record<string, any>) => {
  const { isUnderlined } = props;
  return {
    width: 'auto',
    height: 'auto',
    _text: {
      textDecorationLine: isUnderlined ? 'underline' : 'none',
      fontWeight: 'semibold',
    },
  };
};

const sizes = {
  md: { _text: { fontSize: 'md', lineHeight: 'md' } },
  sm: { _text: { fontSize: 'sm', lineHeight: 'xs' } },
};

const variants = {
  dark: {
    _text: {
      color: 'blue.500',
    },
    _hover: {
      _text: {
        color: 'blue.400',
      },
    },
    _pressed: {
      _text: {
        color: 'blue.600',
      },
    },
    _disabled: {
      _text: {
        color: 'gray.500',
      },
    },
  },
  light: {
    _text: {
      color: 'white',
    },
    _hover: {
      _text: {
        color: 'blue.50',
      },
    },
    _pressed: {
      _text: {
        color: 'blue.100',
      },
    },
    _disabled: {
      _text: {
        color: 'gray.200',
      },
    },
  },
};

export default {
  baseStyle,
  sizes,
  variants,
  defaultProps: {
    isUnderlined: true,
    size: 'md',
    variant: 'dark',
  },
};
